import { shared } from './shared'
import type { Schema } from './types'

export const schema: Schema = {
  ...shared,
  'subscriptions-sign-up-component': {
    default: false,
  },
}
